export enum MailDomain {
    Chevron = "chevron.com",
    Tengizchevroil = "tengizchevroil.com",
}